export const telehealthConstants = {
  TH_CLEAR_STATE: 'TH_CLEAR_STATE',
  TH_PREPEND_MSG: 'TH_PREPEND_MSG',

  SET_CHART_ID: 'SET_CHART_ID',
  SET_GROUP_ID: 'SET_GROUP_ID',
  SET_LAST_NAME: 'SET_LAST_NAME',
  SET_FIRST_NAME: 'SET_FIRST_NAME',
  SET_PROVIDER_ID: 'SET_PROVIDER_ID',
  SET_PATIENT_TYPE: 'SET_PATIENT_TYPE',
  SET_AVAILABLE_ON: 'SET_AVAILABLE_ON',
  SET_DATE_OF_BIRTH: 'SET_DATE_OF_BIRTH',
  SET_PAYMENT_AMOUNT: 'SET_PAYMENT_AMOUNT',
  SET_TELEHEALTH_TYPE: 'SET_TELEHEALTH_TYPE',
  SET_TELEHEALTH_DATE: 'SET_TELEHEALTH_DATE',
  SET_QUESTIONNAIRE_ID: 'SET_QUESTIONNAIRE_ID',
  SET_TELEMEDICINE_TYPE: 'SET_TELEMEDICINE_TYPE',
  SET_CELL_PHONE_NUMBER: 'SET_CELL_PHONE_NUMBER',

  SAVE_TELEHEALTH_REQUEST: 'SAVE_TELEHEALTH_REQUEST',
  SAVE_TELEHEALTH_SUCCESS: 'SAVE_TELEHEALTH_SUCCESS',
  SAVE_TELEHEALTH_FAILURE: 'SAVE_TELEHEALTH_FAILURE',

  GETALL_TELEHEALTHS_INIT: 'GETALL_TELEHEALTHS_INIT',
  GETALL_TELEHEALTHS_REQUEST: 'GETALL_TELEHEALTHS_REQUEST',
  GETALL_TELEHEALTHS_SUCCESS: 'GETALL_TELEHEALTHS_SUCCESS',

  TH_ROOMS_REQUEST: 'TH_ROOMS_REQUEST',
  TH_ROOMS_SUCCESS: 'TH_ROOMS_SUCCESS',

  RETRIEVE_TELEHEALTH_INIT: 'RETRIEVE_TELEHEALTH_INIT',
  RETRIEVE_TELEHEALTH_REQUEST: 'RETRIEVE_TELEHEALTH_REQUEST',
  RETRIEVE_TELEHEALTH_SUCCESS: 'RETRIEVE_TELEHEALTH_SUCCESS',
  RETRIEVE_TELEHEALTH_FAILURE: 'RETRIEVE_TELEHEALTH_FAILURE',

  SET_TELEHEALTH_MSG: 'SET_TELEHEALTH_MSG',
  ADD_TELEHEALTH_MSG: 'ADD_TELEHEALTH_MSG',
  SEND_TELEHEALTH_MSG_REQUEST: 'SEND_TELEHEALTH_MSG_REQUEST',
  SEND_TELEHEALTH_MSG_SUCCESS: 'SEND_TELEHEALTH_MSG_SUCCESS',
  GETALL_TELEHEALTH_MSG_REQUEST: 'GETALL_TELEHEALTH_MSG_REQUEST',
  GETALL_TELEHEALTH_MSG_SUCCESS: 'GETALL_TELEHEALTH_MSG_SUCCESS',
}